import type { TreeGrid } from '../types';
import { createRowDef } from './create-row-def';

export type CreateRowConfig<TColumns extends string = string> = Omit<
  TreeGrid.Row<TColumns>,
  'id'
> & {
  /**
   * @deprecated use Cells instead
   */
  Columns?: TreeGrid.Col<TColumns>[];
  Cells?: TreeGrid.Cell<TColumns>[];
};

export const createRow = <TColumns extends string = string>(
  id: string,
  config?: CreateRowConfig<TColumns>,
) => {
  const _config = config ? createRowDef<TColumns>(config) : {};

  return {
    id,
    ..._config,
  };
};
